import React from 'react';
import * as colors from '../../utils/colors';
import { GRID_UNIT_SIZE } from '../utils/graph.utils';

export const GridBorder: React.FC = () => {
  return (
    <>
      <line
        x1={0}
        y1={0}
        x2='100%'
        y2={0}
        stroke={colors.gridLineColor}
        strokeWidth={GRID_UNIT_SIZE}
      />
      <line
        x1={0}
        y1={0}
        x2={0}
        y2='100%'
        stroke={colors.gridLineColor}
        strokeWidth={GRID_UNIT_SIZE}
      />
      <line
        x1='100%'
        y1={0}
        x2='100%'
        y2='100%'
        stroke={colors.gridLineColor}
        strokeWidth={GRID_UNIT_SIZE}
      />
      <line
        x1={0}
        y1='100%'
        x2='100%'
        y2='100%'
        stroke={colors.gridLineColor}
        strokeWidth={GRID_UNIT_SIZE}
      />
    </>
  );
};
